import { Store } from 'pullstate';
import { DuplicateAccount } from '../types/types';

const DuplicateAccountListStore = new Store({
    duplicates: [] as DuplicateAccount[],
    hasDuplicates: false,
    accountName: '',
    accountId: '',
    open: false,
});

export default DuplicateAccountListStore;
